module.exports = __webpack_public_path__ + "img/Live Nation Image.49ce2397.jpeg";